import type { PeopleSource } from "@playbookai/types";
import { usePeopleSource } from "@playbookai/ui";

/**
 * The tenant `PeopleSource` the host shell provides, for the KPI owner fields
 * (assign-person consistency). KPI keeps no access list, so the shell's source
 * has grant mode `none`. A required field cannot work without one, so a
 * missing provider is a host wiring error, not an empty state.
 */
export function useKpiPeopleSource(): PeopleSource {
  const source = usePeopleSource();
  if (!source) {
    throw new Error(
      "useKpiPeopleSource: PeopleSourceProvider missing. Mount <KpiManager> inside a PeopleSourceProvider (the shell supplies the tenant source).",
    );
  }
  return source;
}
